import sortBy from 'lodash/sortBy';
import type { Service } from 'packages/types';

export function sortServices(services: Array<Service>): Array<Service> {
  return sortBy(services, service => service.ordinal);
}
